module.exports = __webpack_public_path__ + "static/media/图片_05.ffeb2415.jpg";